import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type RememberedColumns = Record<string, string>;

interface ImportMappingMemoryState {
  mappings: Record<string, RememberedColumns>;
  remember: (scope: string, columns: RememberedColumns) => void;
}

export const useImportMappingMemory = create<ImportMappingMemoryState>()(
  persist(
    (set) => ({
      mappings: {},
      remember: (scope, columns) =>
        set((state) => ({
          mappings: {
            ...state.mappings,
            [scope]: { ...state.mappings[scope], ...columns },
          },
        })),
    }),
    {
      name: 'import-mapping-memory',
    },
  ),
);
